// Self-fetching cost-over-time card for a fixed group_by (used on Overview for
// the capacity-type spend chart). Wraps CostTimeseriesChart; hides on CH-off.

import React from 'react';
import { Card, CardContent } from '../ui/card';
import { useCostTimeseries } from '../../hooks/useFinopsV2';
import { SectionHeader, Skeleton, ChDisabledCard, EmptyCard } from './finopsUi';
import CostTimeseriesChart from './CostTimeseriesChart';

export default function CostTrendCard({ clusterId, hours, groupBy = 'capacity_type',
                                        title, hint, top = 8, showForecast = false, hideWhenUnavailable = false }) {
  const { data, loading, available } = useCostTimeseries(clusterId, hours, groupBy, top);
  if (!available) return hideWhenUnavailable ? null : <ChDisabledCard title={`${title || 'Cost trend'} unavailable`} />;
  return (
    <Card className="border border-slate-200 dark:border-surface-border bg-white dark:bg-surface-dark shadow-sm">
      <CardContent className="p-5">
        <SectionHeader title={title || 'Cost over time'} hint={hint || `by ${groupBy}`} />
        {loading ? <Skeleton className="h-72" />
          : data?.series?.length ? <CostTimeseriesChart data={data} windowHours={hours} height={280} showForecast={showForecast} />
          : <EmptyCard message="No cost data in this window" />}
      </CardContent>
    </Card>
  );
}
